<template>
    <x-card class="statuses">
        <x-card-title>
            <x-layout justify-space-between align-center>
                <x-flex>
                    View by status
                </x-flex>

                <x-flex class="text-xs-right grow-0">
                    <x-checkbox
                        hide-details
                        data-test="select-all-checkbox"
                        class="ma-0 no-label dashboard-checkbox"
                        :class="{ indeterminate: statusFilters.length && statusFilters.length < options.length }"
                        v-model="allStatusesSelected"
                        @change="selectAllStatuses"
                    />
                </x-flex>
            </x-layout>
        </x-card-title>

        <x-card-text>
            <ul>
                <li
                    v-for="(filter, index) in options"
                    :key="index"
                    class="status"
                    :class="{ active: statusFilters.includes(filter.value) }"
                >
                    <x-layout justify-space-between align-center fill-height>
                        <x-flex>
                            <span class="status__label" :class="filter.value">{{ filter.text }}</span>
                        </x-flex>

                        <x-flex class="text-xs-right grow-0">
                            <x-checkbox
                                v-model="statusFilters"
                                :value="filter.value"
                                hide-details
                                class="ma-0 no-label dashboard-checkbox"
                                data-test="status-checkbox"
                            />
                        </x-flex>
                    </x-layout>
                </li>
            </ul>
        </x-card-text>
    </x-card>
</template>

<script>
export default {
    props: ['value', 'options'],
    data() {
        return {
            allStatusesSelected: false
        }
    },
    computed: {
        statusFilters: {
            get() {
                return this.value;
            },
            set(value) {
                this.$emit('input', value)
            }
        }
    },
    watch: {
        statusFilters: {
            handler(newStatusFilters) {
                this.allStatusesSelected = newStatusFilters.length === this.options.length;
            },
            immediate: true,
        }
    },
    methods: {
        selectAllStatuses() {
            this.statusFilters = this.allStatusesSelected ? this.options.map(option => {
                return option.value;
            }) : [];
        }
    }
}
</script>

<style lang="scss" scoped>
.x-card.statuses {
    padding: 16px 0;

    .x-card__title {
        padding: 0 16px;
    }
}

.status {
    height: 32px;
    padding: 0 16px;

    &.active {
        background: linear-gradient(90.05deg, rgba(255, 255, 255, 0.1) 37.57%, rgba(255, 255, 255, 0.02) 77.35%);

        .status__label {
            &.draft {
                &::before {
                    background: $color-draft;
                }
            }

            &.in_the_market {
                &::before {
                    background: $color-in-the-market;
                }
            }

            &.ntu {
                &::before {
                    background: $color-ntu;
                }
            }

            &.declined {
                &::before {
                    background: $color-declined;
                }
            }

            &.firm_ordered {
                &::before {
                    background: $color-firm-ordered;
                }
            }

            &.bound {
                &::before {
                    background: $color-bound;
                }
            }

            &.expired {
                &::before {
                    background: $color-expired;
                }
            }

            &.closed {
                &::before {
                    background: $color-closed;
                }
            }

            &.off_risk {
                &::before {
                    background: $color-off-risk;
                }
            }

            &.not_taken_to_market {
                &::before {
                    background: $color-not-taken-to_market;
                }
            }

            &.nbi {
                &::before {
                    background: $color-nbi;
                }
            }
        }
    }
}

.status__label {
    position: relative;
    padding-left: 24px;
    font-size: rem(14px);

    &::before {
        content: '';
        position: absolute;
        left: 0;
        top: 50%;
        transform: translateY(-50%);
        width: 12px;
        height: 12px;
        border-radius: 12px;
        background: rgba(255, 255, 255, 0.1);
    }
}
</style>
